__turbopack_context__.v({
  "page": "Page-module__RGmMeq__page",
});
